var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import FontIcon from './FontIcon';
import OcListeners from './utils/OcListeners';

var Modal = (_temp2 = _class = function (_OcListeners) {
  _inherits(Modal, _OcListeners);

  function Modal() {
    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _OcListeners.call.apply(_OcListeners, [this].concat(args))), _this), _this.closeModal = function (e) {
      var _this$props = _this.props,
          onCloseModal = _this$props.onCloseModal,
          show = _this$props.show;

      if (show) {
        onCloseModal(e);
      }
    }, _this.noClick = function (e) {
      // Prevents closing the modal when clicking the content, only the wrapper.
      if (e) {
        e.stopPropagation();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Modal.prototype.componentDidMount = function componentDidMount() {
    var Keys = this.Keys;

    this.addKeyListener(Keys.escape, this.closeModal);
  };

  // eslint-disable-next-line camelcase


  Modal.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.show) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }
  };

  Modal.prototype.componentWillUnmount = function componentWillUnmount() {
    this.removeKeyListener();
    document.body.classList.remove('modal-open');
  };

  Modal.prototype.render = function render() {
    var _classNames;

    var _props = this.props,
        bodyPadding = _props.bodyPadding,
        children = _props.children,
        className = _props.className,
        hideCloseButton = _props.hideCloseButton,
        ocSize = _props.ocSize,
        ocStyle = _props.ocStyle,
        onCloseModal = _props.onCloseModal,
        show = _props.show,
        title = _props.title,
        other = _objectWithoutProperties(_props, ['bodyPadding', 'children', 'className', 'hideCloseButton', 'ocSize', 'ocStyle', 'onCloseModal', 'show', 'title']);

    if (!show) {
      return null;
    }

    var modalClass = classNames('modal', className, (_classNames = {}, _classNames['modal-' + ocSize] = ocSize, _classNames['modal-' + ocStyle] = ocStyle, _classNames));

    var bodyClass = classNames('modal__body', {
      'p-n': !bodyPadding
    });

    return React.createElement(
      'div',
      _extends({ className: modalClass }, other),
      React.createElement(
        'div',
        { className: 'modal__wrapper', onClick: this.closeModal },
        React.createElement(
          'div',
          { className: 'modal__content', onClick: this.noClick },
          React.createElement(
            'div',
            { className: 'modal__header' },
            title,
            hideCloseButton ? null : React.createElement(
              'button',
              { type: 'button', className: 'modal__close', onClick: this.closeModal },
              React.createElement(
                'span',
                { className: 'visually-hidden' },
                'Close Modal'
              ),
              React.createElement(FontIcon, { icon: 'close' })
            )
          ),
          React.createElement(
            'div',
            { className: bodyClass },
            children
          )
        )
      )
    );
  };

  return Modal;
}(OcListeners), _class.propTypes = {
  bodyPadding: PropTypes.bool,
  children: PropTypes.node.isRequired,
  hideCloseButton: PropTypes.bool,
  ocSize: PropTypes.oneOf(['sm', 'lg']),
  ocStyle: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'success', 'info', 'warning', 'danger']),
  onCloseModal: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  title: PropTypes.string
}, _class.defaultProps = {
  bodyPadding: true,
  hideCloseButton: false,
  ocStyle: 'secondary'
}, _temp2);
export { Modal as default };